import { render, staticRenderFns } from "./CustomFieldFormDialog.vue?vue&type=template&id=a06c0b0a&"
import script from "./CustomFieldFormDialog.vue?vue&type=script&lang=js&"
export * from "./CustomFieldFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports